const COLUMNS_EXCLUDED_ITEMS = [
  { label: 'date', className: 'align-left' },
  { label: 'nuOrder', className: 'align-left' },
  { label: 'user', className: 'align-left' },
  { label: 'reason', className: 'align-left' },
]

export { COLUMNS_EXCLUDED_ITEMS }
